module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Regular-b130f1fba261011d315f062b973e0a4a.ttf";